/* eslint-disable no-new */
import Layzr from 'layzr.js'
import SmoothScroll from 'smoothscroll-for-websites'
import documentReady from '../utilities/documentReady'
import GlobalNavi from './GlobalNavi'
import Scroller from './Scroller'
import StickyHeader from './StickyHeader'
import FooterScroller from './FooterScroller'
import loading from './Loading'
import storageManager from './storageManager'

documentReady(() => {
  const layzr = Layzr()
  layzr.on('src:after', function (el) {
    const img = new Image()
    img.onload = () => {
      el.classList.add('is-loaded')
    }
    img.src = el.src
  })
  layzr.update().check().handlers(true)

  SmoothScroll({ stepSize: 75 })

  storageManager.reset()

  new GlobalNavi()
  new Scroller('.js-scroller')
  new StickyHeader()
  new FooterScroller()

  setTimeout(() => {
    loading()
  }, 500)
})



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/modules/common.js